<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="pgepubid00006">
<h2><a id="part02">— II —</a></h2><a id="part02">
</a></div><a id="part02">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 2527055923605270645_4300h5.htm.vue?5821230e